<template>


</template>

<script>
	export default {

	}
</script><template>
	<div class="file-input">
		<label>{{ label }}</label>
		<div v-if="file">
			<a :href="src" v-if="src" :download="name">{{ name }}</a>
		</div>
		<div class="actions">
			<button @click.prevent="chooseFile">Upload</button>
			<transition name="fade" mode="out-in">
				<button @click.prevent="file = null" v-if="file">Remove</button>
			</transition>
		</div>
		<transition name="slide-down">
            <div class="error-text" v-if="errors && errors.length > 0">
                <div v-for="error in errors">{{ error }}</div>
            </div>
        </transition>
		<input type="file" style="display: none;" ref="file" @change="updateSrc" :accept="accept" />
	</div>
</template>

<script>
	export default {
		props: ['value', 'disabled', 'label', 'accept', 'errors'],
		data() {
			return {
				file: this.value
			};
		},
		computed: {
			name() {
				if(!this.file) {
					return null;
				}
				if(typeof(this.file) === 'string') {
					return this.file;
				}
				if(typeof(this.file) === 'object') {
					return this.file.name;
				}
			},
			src() {
				if(!this.file) {
					return null;
				}
				if(typeof(this.file) === 'string') {
					return this.file;
				}
				if(typeof(this.file) === 'object') {
					return URL.createObjectURL(this.file);
				}
			}
		},
		watch: {
			value() {
				this.file = this.value;
			},
			file() {
				this.$emit('input', this.file);
			}
		},
		methods: {
			chooseFile() {
				if(this.disabled){
					return;
				}
				this.$refs.file.dispatchEvent(new MouseEvent('click'));
			},
			updateSrc(event) {
				if(this.disabled){
					return;
				}
				this.file = event.currentTarget.files[0];
				event.currentTarget.value = '';
			}
		}
	}
</script>